import { Injectable } from '@angular/core';
import { SMSQueueData } from 'src/lib/fliko/models/messageQueue/sms.data';
import { DatabaseService } from './database.service';

@Injectable({ providedIn: 'root' })
export class SendSMSService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /sendSMSQueue/
   * @key id
   */
  private get sendEmailQueue() {
    return this.dbSrv.commonFactory.getCollection<SMSQueueData>('sendSMSQueue');
  }

  public sendSMS(data: SMSQueueData): Promise<void> {
    return this.sendEmailQueue.setElement(data.id, data);
  }
}
